import { useDynamicContext } from "@dynamic-labs/sdk-react-core"
import { Button } from "@/components/ui/button"
import { useNavigate } from "react-router-dom"
import { useQueryClient } from "@tanstack/react-query"
import SettingsCard from "./settings.card"
import UserIcon from "@/components/icons/user"
import WalletIcon from "@/components/icons/wallet"
import BankIcon from "@/components/icons/bank"
import WebhookIcon from "@/components/icons/webhook"
import KeyIcon from "@/components/icons/key"

export default function SettingsScreen() {
  const { handleLogOut } = useDynamicContext()
  const navigate = useNavigate()
  const queryClient = useQueryClient()

  const onSignOut = () => {
    handleLogOut()
    queryClient.clear()
    navigate("/")
  }

  return (
    <div className="flex flex-col gap-4 items-start">
      <div className="grid md:grid-cols-3 w-full gap-5">
        <SettingsCard
          title="Account"
          description="Update your personal details"
          icon={<UserIcon />}
          iconColor="bg-green-500"
          to="/settings/account"
        />
        <SettingsCard
          title="Wallet"
          description="Export or backup your wallet"
          icon={<WalletIcon />}
          iconColor="bg-blue-500"
          to="/settings/wallet"
          testid="wallet-settings"
        />
        <SettingsCard
          title="Bank Accounts"
          description="Manage your bank accounts"
          icon={<BankIcon />}
          iconColor="bg-red-600"
          to="/settings/bank-accounts"
          testid="bank-accounts-settings"
        />
        <SettingsCard
          title="Webhooks"
          description="Configure webhook notifications for payments"
          to="/settings/webhook"
          icon={<WebhookIcon />}
          iconColor="bg-purple-500"
        />
        <SettingsCard
          title="API Keys"
          description="Manage your publishable and secret keys"
          to="/settings/api-keys"
          icon={<KeyIcon />}
          iconColor="bg-orange-500"
        />
      </div>

      <Button variant="outline" onClick={onSignOut}>
        Sign out
      </Button>
    </div>
  )
}
